import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=9b74c41a&scoped=true&"
import script from "./Budgets.vue?vue&type=script&lang=js&"
export * from "./Budgets.vue?vue&type=script&lang=js&"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=9b74c41a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b74c41a",
  null
  
)

export default component.exports